import react, { useState } from "react";
import Header from "./Header";

const HeaderNavBar = () => {
  const [showNames, setShowNames] = useState(false);
  return (
    <>
      <aside className={`${showNames ? "w-[200px]" : 'w-[70px] py-4 my-[10px]'} xl:h-full lg:h-full h-10 header ml-3 transition-all duration-300 ease-in-out bg-[#EBF5FF] shadow-lg flex flex-col items-center rounded-[20px] overflow-x-hidden custom-side-scrollbar`}
      >
        <div className="flex flex-col  space-y-6">
          <Header setShowNames={setShowNames} showNames={showNames} />
        </div>
      </aside>
    </>
  )

}

export default HeaderNavBar;